import { Navigate, RouteObject } from "react-router-dom";
import MDFeView from "./MDFe.View";
import MDFeCadastroView from "./Cadastro/MDFe.Cadastro";
import MDFeCadastroIdentificacaoView from "./Cadastro/MDFe.Cadastro.Identificacao.View";
import MDFeCadastroPercursoView from "./Cadastro/MDFe.Cadastro.Percurso.View";
import MDFeCadastroVeiculoView from "./Cadastro/MDFe.Cadastro.Veiculo.View";
import MDFeCadastroCarregamentoView from "./Cadastro/MDFe.Cadastro.Carregamento.View";
import MDFeCadastroDocumentosView from "./Cadastro/MDFe.Cadastro.Documentos.View";
import MDFeCadastroTotaisView from "./Cadastro/MDFe.Cadastro.Totais.View";
import MDFeCadastroContratantesView from "./Cadastro/MDFe.Cadastro.Contratantes.View";
import MDFeCadastroPagamentoView from "./Cadastro/MDFe.Cadastro.Pagamento.View";
import MDFeCadastroFinalizacaoView from "./Cadastro/MDFe.Cadastro.Finalizacao.View";
import MDFeEventoView from "./Evento/MDFe.Evento.View";
import MDFeVisualizaView from "./Visualiza/MDFe.Visualiza.View";

export const MDFeRoutes: RouteObject[] = [
  {
    path: "fiscal/mdfe",
    element: <MDFeView />,
    children: [],
  },
  {
    path: "fiscal/mdfe/:id/visualizar",
    element: <MDFeVisualizaView />,
  },
  {
    path: "fiscal/mdfe/visualizar/:id",
    element: <MDFeVisualizaView />,
  },
  {
    path: "fiscal/mdfe/evento",
    element: <MDFeEventoView />,
  },
  {
    path: "fiscal/mdfe/cadastro",
    element: <MDFeCadastroView />,
    children: [
      { index: true, element: <Navigate to="identificacao" replace /> },
      { path: "identificacao", element: <MDFeCadastroIdentificacaoView /> },
      { path: "percurso", element: <MDFeCadastroPercursoView /> },
      { path: "veiculo", element: <MDFeCadastroVeiculoView /> },
      { path: "carregamento", element: <MDFeCadastroCarregamentoView /> },
      { path: "documentos", element: <MDFeCadastroDocumentosView /> },
      { path: "totais", element: <MDFeCadastroTotaisView /> },
      { path: "contratantes", element: <MDFeCadastroContratantesView /> },
      { path: "pagamento", element: <MDFeCadastroPagamentoView /> },
      { path: "finalizacao", element: <MDFeCadastroFinalizacaoView /> },
    ],
  },
];
